import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.667"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M20 4.333H1m6.706 5.556.559 5.555m5.029-5.555-.559 5.555"
      }),
      _createElementVNode("path", { d: "M4.353 4.333h.122A2.23 2.23 0 0 0 6.52 2.867l.04-.115.108-.323c.093-.277.139-.415.2-.532a1.68 1.68 0 0 1 1.223-.876C8.222 1 8.369 1 8.661 1h3.677c.293 0 .44 0 .57.02.525.084.978.409 1.223.877.062.117.108.255.2.532l.11.323c.02.059.029.089.039.115a2.23 2.23 0 0 0 2.167 1.466" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M17.623 14.777c-.198 2.95-.297 4.425-1.263 5.324-.967.899-2.454.899-5.428.899h-.864c-2.974 0-4.46 0-5.428-.9-.966-.898-1.065-2.373-1.263-5.323L2.863 7.11m15.274 0-.223 3.333"
      })
    ], -1)
  ]))]))
}
export default { render: render }